<template>
  <check-base-layout :show-mark="false" :pagetitle="pagetitle" :check-info-data="checkFrom">
    <template>
      <check-module :title="`合同总览`">
        <compart-module :compart-data="checkFrom.purchaseContractBasesVo" :isCustomer="false"></compart-module>
      </check-module>
      <div>
        <supplier-module :supplier-data="purchaseContractBaseProductVo"></supplier-module>
        <check-module :title="`采购清单`" :is-table="true">
          <info-table
            :field-arr="bFieldArr"
            :table-data="purchaseUnsignVoList"
            :to-fixed-format="[
              'purchasePrice',
              'discountPrice',
              'actuallyPirce',
              'proPrice'
            ]"
            :table-height="`300px`"
          ></info-table>
          <div class="allfield_title">总计</div>
          <info-table
            :field-arr="allFieldArr"
            :table-data="aTableData"
            :to-fixed-format="['purchaseTotal', 'discountTotal', 'actualTotal']"
            :table-height="aTableData.length ? `73px` : 'auto'"
          ></info-table>
        </check-module>
        <check-module :title="`账期设置`" :is-table="true">
          <div
            :class="{
              pb20: purchaseBaseApprovalContractVo.payType !== '约定账期'
            }"
          >
            <el-row style="padding: 0 0 20px 20px;">
              <el-col :span="8">
                <div>
                  合同金额：{{
                  purchaseBaseApprovalContractVo.contractMoney | toFixed
                  }}
                </div>
              </el-col>
              <el-col :span="8">
                <div>付款类型：{{ purchaseBaseApprovalContractVo.payType }}</div>
              </el-col>
              <el-col :span="8">
                <div v-if="!purchaseBaseApprovalContractVo.replenMark">补充说明：{{ '--' }}</div>
                <el-tooltip
                  v-else
                  class="item"
                  effect="dark"
                  :content="purchaseBaseApprovalContractVo.replenMark"
                  placement="top"
                >
                  <span class="ellipsis-text">补充说明：{{ purchaseBaseApprovalContractVo.replenMark }}</span>
                </el-tooltip>
              </el-col>
            </el-row>
            <el-row style="padding-left: 20px;">
              <el-col :span="8" v-if="purchaseBaseApprovalContractVo.payType === '约定账期'">
                <div>
                  约定条件：{{
                  purchaseBaseApprovalContractVo.appointTypeValue
                  }}
                </div>
              </el-col>
            </el-row>
          </div>
          <el-table
            :data="zqtableData"
            :span-method="arraySpanMethod"
            :header-cell-style="tableHeader"
            border
            v-if="
              purchaseBaseApprovalContractVo.payType === '全款发货' ||
                purchaseBaseApprovalContractVo.payType === '先货后款'
            "
            style="width: 100%"
          >
            <el-table-column prop="paytype" label="付款项">
              <template v-slot="{ row }">
                <div :style="{ 'text-align': row.isbing ? 'center' : 'left' }">{{ row.paytype }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="money" label="金额"></el-table-column>
            <el-table-column prop="point" label="比例"></el-table-column>
          </el-table>
        </check-module>
        <check-module :title="`收货信息`" :is-table="true">
          <el-form :model="params" style="padding-left:20px;">
            <el-row v-show="params.flag === true">
              <el-col :span="8">
                <el-form-item label="备货仓：">{{params.storageName || '--'}}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item >
                  <div class="flex">
                    <div class="nowrap">收货地址：</div>
                    <div>{{params.address || '--'}}</div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="联系电话：">
                  <span>{{params.phone || '--'}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="params.flag === false && params.stockupType === '入库备货'">
              <el-col :span="8">
                <el-form-item label="备货仓：">{{params.storageName || '--'}}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="">
                  <!-- <span>{{params.address || '--'}}</span> -->
                  <div class="flex">
                    <div class="nowrap">仓库地址：</div>
                    <div>{{params.address || '--'}}</div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="联系电话：">
                  <span>{{params.phone || '--'}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="params.flag === false && params.stockupType === '直发备货'">
              <el-col :span="8">
                <el-form-item label="收货人：">{{params.receivePeople || '--'}}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="">
                  <!-- <span>{{params.receiveAddress || '--'}}</span> -->
                  <div class="flex">
                    <div class="nowrap">收货地址：</div>
                    <div>{{params.receiveAddress || '--'}}</div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="联系电话：">
                  <span>{{params.receivePhone || '--'}}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </check-module>
      </div>
    </template>
    <template #checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module :check-data="systemFlowRunAuditOrgVo"></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import checkApi from '@/api/workbench/check'
import poMixins from '@/mixin/poMixins'
import { isSuccess } from '@/util/tool'
import { deepClone } from '@/util'

export default {
  name: 'poPactCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '采购合同审批'
    }
  },
  data() {
    return {
      params: {}, // 收货信息
      purchaseBaseApprovalContractVo: {}, // 账期设置
      purchaseContractBaseProductVo: {}, // 供应商信息
      systemFlowRunAuditOrgVo: {}, // 审批信息
      purchaseUnsignVoList: [],
      zqtableData: [],
      aTableData: [],
      allFieldArr: [
        {
          name: 'productClass',
          label: '产品种类'
        },
        {
          name: 'purchaseTotal',
          label: '采购总额'
        },
        {
          name: 'discountTotal',
          label: '抵扣金额'
        },
        {
          name: 'actualTotal',
          label: '实付总额'
        }
      ],
      zqtableField: [
        {
          name: 'paytype',
          label: '付款项'
        },
        {
          name: 'money',
          label: '金额'
        },
        {
          name: 'point',
          label: '比例'
        }
      ],
      bFieldArr: [
        {
          name: 'brandName',
          label: '品牌'
        },
        {
          name: 'seriesName',
          label: '系列'
        },
        {
          name: 'proName',
          label: '产品名称'
        },
        {
          name: 'proModel',
          label: '型号'
        },
        {
          name: 'proOrdernum',
          label: '订货号'
        },
        {
          name: 'pccCount',
          label: '数量'
        },
        {
          name: 'proUnit',
          label: '单位'
        },
        {
          name: 'proExtype',
          label: '类型'
        },
        {
          name: 'pcbExtimeValue',
          label: '货期',
          formatter(val) {
            if (!val) return '--'
            const d = val.split('-')
            if (d.length !== 2) return val
            return val + '天'
          }
        },
        {
          name: 'cbRemind',
          label: '提醒',
          formatter(val) {
            if (!val) return '--'
            return val
          }
        },
        {
          name: 'purchasePrice',
          label: '采购单价'
        },
        {
          name: 'discountPrice',
          label: '抵扣金额'
        },
        {
          name: 'actuallyPirce',
          label: '实付单价 '
        },
        {
          name: 'proPrice',
          label: '面价'
        }
      ]
    }
  },
  mounted() {
    this.getPoPactCheckInfo()
  },
  watch: {
    checkFrom() {
      let { checkFrom, zqtableData } = this
      checkFrom = this.formatterData(checkFrom)
      const a = checkFrom.purchaseBaseApprovalContractVo || {}
      this.purchaseBaseApprovalContractVo = a
      this.purchaseContractBaseProductVo = checkFrom.purchaseContractBaseProductVo || {}
      this.systemFlowRunAuditOrgVo = checkFrom.systemFlowRunAuditOrgVo || {}
      this.purchaseUnsignVoList = checkFrom.purchaseUnsignVoList || []
      if (checkFrom.purchaseBaseApprovalContractVo) {
        if (a.advanceAmount) {
          zqtableData.push({
            paytype: '预付款',
            money: a.advanceAmount.toFixed(2),
            point: ((a.advanceAmount / a.contractMoney) * 100).toFixed(2) + '%'
          })
        }
        if (a.goodAmount) {
          zqtableData.push({
            paytype: '货款',
            money: a.goodAmount.toFixed(2),
            point: ((a.goodAmount / a.contractMoney) * 100).toFixed(2) + '%'
          })
        }
        if (a.guaranteeAmount) {
          zqtableData.push({
            paytype: '质保金',
            money: a.guaranteeAmount.toFixed(2),
            point: ((a.guaranteeAmount / a.contractMoney) * 100).toFixed(2) + '%'
          })
        }
        if (a.guaranteeTime) {
          zqtableData.push({
            paytype: '质保期限：' + a.guaranteeTime,
            isbing: true
          })
        }
      }
      this.zqtableData = zqtableData
      if (checkFrom.contractFrom === '采购计划') {
        this.bFieldArr.push({
          name: 'deliveryTime',
          label: '预计发货时间',
          formatter(val) {
            const d = new Date(val)
            return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
          }
        })
      }
      this.$emit('update:data', checkFrom)
      return checkFrom
    }
  },
  methods: {
    getPoPactCheckInfo() {
      const { snaId } = this
      checkApi.getPoPactCheckInfo({ snaId }).then(res => {
        if (isSuccess(res)) {
          this.checkFrom = res.data.obj
          console.log(this.checkFrom)
          this.aTableData[0] = res.data.obj
          this.aTableData = deepClone(this.aTableData)
          this.params = res.data.obj.goodContentVO
        }
      })
    },
    arraySpanMethod({ row }) {
      if (row.isbing) return [1, 3]
      return [1, 1]
    }
  }
}
</script>

<style lang="less" scoped>
  .flex{
    display: flex;
  }
  .nowrap{
    white-space: nowrap;
  }
</style>
